export default "__VITE_ASSET__e900c89e__"